import '../App.css';
import { Button, Navbar, Nav } from 'react-bootstrap';
import 'sf-font';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram, faDiscord } from '@fortawesome/free-brands-svg-icons';
import React, { Component } from 'react';

class App extends Component {
 
  
  render() {
   
    const currentYear = new Date().getFullYear();

return (

  <header className="App-header">
    <div className='container' style={{ background: "#000000" }}>
      
     
    <div className="nftminter" style={{ border: "0", borderRadius: "5px", background: "transparent", marginTop: "10px", marginBottom: "10px", }}>
             
             <Navbar collapseOnSelect expand="md"  variant="dark" style={{ color: 'transparent', background: "transparent", marginRight: "3px",marginLeft: "3px", border: "0", }}>
             
             
             <div className="social-icons">
             <a href="https://twitter.com/JustPoly">
   <FontAwesomeIcon icon={faTwitter} type= "button"size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faTelegram} size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faDiscord} size="lg" className="social-icon" />
   </a>
   
   <style>
     {`
       .social-icons {
         display: flex;
         justify-content: center;
       
         color: #ccc;
         margin-right: auto;
       }

       .social-icon {
         margin-right: 10px;
         margin-left: 10px;
       }

       a {
         color: #ccc;
       }
       a:hover {
         color:#aaa;
        
       }


       @media (max-width: 768px) {
         .social-icons {
           display: flex;
           justify-content: left;
          
           color: #ccc;
           
        
         }
       }
     `}
   </style>
 </div>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{color:"transparent", background: "transparent", marginTop: "auto", border: "0", }}/>
       
        <Navbar.Collapse id="responsive-navbar-nav"  style={{textAlign: "left", background: "transparent", marginTop: "auto", border: "0", }}>
        
         <Nav className="mr-auto ml-auto ml-lg-0" >
         <Button variant="default" href="/" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>HOME</Button>
         <Button variant="default" href="/about" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>ABOUT</Button>
         <Button variant="default" href="/tokenInfo" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >TOKEN INFO</Button>
         <Button variant="default" href="/roadmap" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >ROADMAP</Button>
        <Button variant="default" href="" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >STAKED</Button>    
       </Nav></Navbar.Collapse></Navbar></div>

         


 
<div className='nftminter' style={{ background: "transparent", marginTop: "auto", border: "0", }}>
               
<label id='text' style={{ textAlign: "left", margin: "auto", color: "#ccc",marginTop: "auto", fontWeight: "bold", fontSize: "15px" }}>
              
            
                       

<ul><li>Introduction :
Just Poly is an exciting project aimed at fostering a vibrant community within the Polygon enthusiast circle. With the introduction of NFTs called Just Poly Genesis, the project aims to empower its members by providing them the freedom to share various aspects of their creativity and passions. With a substantial supply of 850,000,000 JP tokens, Just Poly ensures a long-term commitment to all community members.
</li></ul>

<ul><li>Creating a Community :
At the heart of Just Poly lies the vision to create a strong and supportive community. By embracing the power of blockchain technology and the Polygon network, Just Poly brings together individuals passionate about exploring and engaging with various forms of art, culture, and innovation.
</li></ul>


<ul><li>Just Poly Genesis NFTs :
One of the key elements driving the Just Poly community is the unique Just Poly Genesis NFTs. These NFTs serve as a symbol of membership within the community and provide exclusive benefits and opportunities. Holding a Just Poly Genesis NFT grants individuals access to a range of privileges, including participation in exclusive events, early access to new releases, and the ability to contribute to community-driven initiatives.
</li></ul>
    
<ul><li>The Power of Freedom :
Just Poly firmly believes in the power of freedom when it comes to creative expression. As a holder of a Just Poly Genesis NFT, community members have the liberty to share and showcase their talents, interests, and projects with fellow community enthusiasts. This freedom allows for a diverse and vibrant exchange of ideas, fostering collaboration and growth within the community.
</li></ul>   

<ul><li>Long-Term Commitment :
With 850,000,000 JP tokens, Just Poly demonstrates a long-term commitment to its community members. These tokens serve as a binding force, aligning the interests and goals of everyone involved. Just Poly aims to continuously innovate, explore new opportunities, and evolve alongside its community, ensuring a sustainable and prosperous future.
</li></ul>

<ul><li>Join the Just Poly Community :
If you are passionate about the Polygon network and eager to be part of a dynamic community that celebrates creativity, collaboration, and innovation, then Just Poly is the place for you. By acquiring a Just Poly Genesis NFT, you gain access to a world of endless possibilities and connections within the Polygon enthusiast community.
</li></ul>

<ul><li>Conclusion :
Just Poly is more than just a project, it is a community-driven initiative that thrives on the collective passion, talent, and creativity of its members. Through the power of Just Poly Genesis NFTs, the project empowers individuals to express themselves, collaborate, and explore new horizons. Join the Just Poly community and be part of an exciting journey in the Polygon enthusiast circle.
</li></ul>
      
      <style>
        {`
      

       c {
           max-width: 800px;
            margin: 10px;
          }

        h1, h2, p, li {
          text-align: left;
          margin: 10px;
        
          max-width: auto;
          font-weight:bold;
          color:#ccc;
        }
        h2 {
         
          margin-top: 10px;
        
        }
        ul {
          padding-left: 20px;
          margin: auto;
          
          
        }

        @media (max-width: 768px) {
          c {
            font-size: 12px;
            margin: auto;
            text-align: left;
            
          }
        }
      `}</style>
                  </label>
              </div>

              
        




      
      <div className='footer' style={{ background: "transparent", border: "0" }}>
        <div className='col'>
         
          <b>&copy; {currentYear} JUST POLY DAPP</b>
          <style>{`
  
        b {
          text-align: center;
          font-size: 14px;
          font-weight: arial;
        }

      
      `}</style>
        </div>
      </div>
    </div>
  </header>
);
}
}

export default App;